/*
Components that should be bundled in the main.js file:
*/
import Loadable from 'react-loadable'
import HeroArticle from '../components/Hero/HeroArticle'
import HeroSection from '../components/Hero/HeroSection'
import HeroFront from '../components/Hero/HeroFront'
import HeroExhibition from '../components/Hero/HeroExhibition'
import HeroVideo from "../components/Hero/HeroVideo/HeroVideo";
import ListFiltered from '../components/ListFiltered/ListFiltered'
import ListFeatured from '../components/ListFeatured/ListFeatured'
import AudioGuidesList from '../components/AudioGuideComponents/AudioGuidesList/AudioGuidesList'
import AudioGuideEpisodesList from '../components/AudioGuideComponents/AudioGuideEpisodesList/AudioGuideEpisodesList'
import GuideMenu from '../components/GuideMenu/GuideMenu'

const Loading = () => null


/*
Components that should be lazy-loaded (code-splitting):
*/
const AsyncAudioPlayer = Loadable({loader: () => import('../components/AudioPlayer/AudioPlayer'), loading: Loading})
const AsyncSoundCloudPlayer = Loadable({loader: () => import('../components/SoundCloudPlayer/SoundCloudPlayer'), loading: Loading})
const AsyncBranchMenu = Loadable({loader: () => import('../components/BranchMenu/BranchMenu'), loading: Loading})
const AsyncCampaignContainer = Loadable({loader: () => import('../components/Campaign/CampaignContainer'), loading: Loading})
const AsyncGallery = Loadable({loader: () => import('../components/Gallery/Gallery'), loading: Loading})
const AsyncInfoViewer = Loadable({loader: () => import('../components/InfoScreenViewer/InfoScreenViewer'), loading: Loading})
const AsyncList = Loadable({loader: () => import('../components/List/List'), loading: Loading})
const AsyncRelated = Loadable({loader: () => import('../components/Related/Related'), loading: Loading})
const AsyncRibbonDescriptionLists = Loadable({loader: () => import('../components/DescriptionLists/DescriptionLists'), loading: Loading})
const AsyncRibbonRichText = Loadable({loader: () => import('../components/RichText/RichText'), loading: Loading})
const AsyncVideo = Loadable({loader: () => import('../components/Video/Video'), loading: Loading})

export const ComponentType = Object.freeze({
  audioplayer: AsyncAudioPlayer,
  audio: AsyncSoundCloudPlayer,
  subpages: AsyncBranchMenu,
  campaign: AsyncCampaignContainer,
  exhibition_hero: HeroExhibition,
  gallery: AsyncGallery,
  frontpage_hero: HeroFront,
  video_hero: HeroVideo,
  section_hero: HeroSection,
  article_hero: HeroArticle,
  InfoViewer: AsyncInfoViewer,
  List: AsyncList,
  featured_items: ListFeatured,
  list_items: ListFiltered,
  related_content: AsyncRelated,
  description_list: AsyncRibbonDescriptionLists,
  rich_text: AsyncRibbonRichText,
  search_items: ListFiltered,
  video: AsyncVideo,
  audio_guides: AudioGuidesList,
  audio_guide: AudioGuideEpisodesList,
  guide_menu: GuideMenu,
});



// WEBPACK FOOTER //
// ./src/constants/consts-component-type.js